import React from 'react';
import { connect } from 'react-redux';
import Card from './Card';

class Category extends React.Component {
  render() {
    const { selftest_category_id } = this.props;
    const { categories } = this.props.selftest;

    const category = categories.find(c => c.id === selftest_category_id);

    if (!category) {
      return (
        <div className="bg-corporate text-white p-3 rounded mt-3">
          Please select a category in the WordPress admin.
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center">
        <div style={{maxWidth: 500, width: '100%'}}>
          <div className="text-center text-corporate mb-2">
            <h4>{category.name}</h4>
          </div>
          <Card id={category.id} />
        </div>
      </div>
    );
  }
}

const mapStoreToProps = (store) => ({
  selftest: store.selftest,
});

export default connect(mapStoreToProps)(Category);
